import { createSlice } from "@reduxjs/toolkit";
const Carttslice = createSlice({
    name : "cartt",
    initialState : {
        loading : false,
        items : localStorage.getItem("cartitems")? JSON.parse(localStorage.getItem("cartitems")) :[]
    },
    reducers:{
        carttrequest : (state,action)=>{
            state.loading = true
            console.log(state.loading)

        },
       addtocartt : (state,action)=>{
            const item = action.payload
            console.log(item)
            const isItemExists = state.items.find( ele => ele.num === item.num);
            if(isItemExists){
                state.items = state.items;
                state.loading = false;
            }else{
                state.items = [...state.items,item]
                state.loading = false;
                localStorage.setItem("cartitems",JSON.stringify(state.items));
                console.log(state.items)
            }
            
            
        },
        increaseCartQty : (state,action) =>{
            const constdecqty = state.items.map(item => {
                if(item.num === action.payload){
                    if(item.stock > item.quantity){
                        item.quantity = item.quantity+1

                    }else{
                        alert("Out of Stock")
                    }
                    
                }
                return item;
                
            })
            state.items  = constdecqty
           
            localStorage.setItem("cartitems",JSON.stringify(state.items));
        },
        decreaseCartQty : (state,action) =>{
            const constdecqty = state.items.map(item => {
                if(item.num === action.payload){
                    if(item.quantity >1){
                        item.quantity = item.quantity-1

                    }else{
                        alert("Minimum Item should be one")
                    }
                  
                }
                return item;
                
            })
            state.items  = constdecqty
           
            localStorage.setItem("cartitems",JSON.stringify(state.items));
        },
        removefromcartt : (state,action) =>{
            const filteritems = state.items.filter((item)=>{
                return item.num  !== action.payload
            })
            state.items = filteritems
            localStorage.setItem("cartitems",JSON.stringify(filteritems));
            

        },

        
    }
})

export default Carttslice;